<template>
  <div id="detail-order-view">
    <div class="detail-order-view-header">
      <h1>{{$_('order_detail_text_info', {order_number, tref})}}</h1>
      <p>{{$_('order_detail_text')}}</p>
    </div>
    <DetailOrderResearch />
    <DetailOrderList />
    <OrderDetailsInfo />
  </div>
</template>

<script>
import DetailOrderResearch from "../components/DetailOrderResearch";
import DetailOrderList from "../components/DetailOrderList";
import OrderDetailsInfo from "../components/OrderDetailsInfo";
import orderService from '@/modules/commande/services/orderService.js';

export default {
  data() {
    return {
      order_number: '',
      tref: ''
    }
  },
  components: {
    DetailOrderResearch,
    DetailOrderList,
    OrderDetailsInfo
  },
  created() {

    this.$store.dispatch('commande/RESET_STATE');

    this.order_number = this.$route.params.order_id

    orderService.getOrderDetailsInfo(this.order_number)
    .then(res => {
      if(res.data.DS_O !== undefined) { 
        this.tref = res.data.DS_O.OUT.TREF;
      }
    });
  }
};
</script>

<style scoped>
.detail-order-view-header {
  padding: 20px;
}
</style>